import { render } from "./CreatedInfo.vue?vue&type=template&id=013df582"
import script from "./CreatedInfo.vue?vue&type=script&lang=js"
export * from "./CreatedInfo.vue?vue&type=script&lang=js"

import exportComponent from "/home/aaicom7/repositories/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__